import { ThemeProvider } from '@mui/material';
import React, { useState } from 'react';

import { themeCreator } from './base';
// import { CacheProvider } from '@emotion/react';
// import createCache from '@emotion/cache';
// import stylisRTLPlugin from 'stylis-plugin-rtl';

// const cacheRtl = createCache({
//   key: 'bloom-ui',
// prepend: true,
//   // @ts-ignore
//   stylisPlugins: [stylisRTLPlugin]
// });

interface Props {
  children: React.ReactElement;
}

export const ThemeContext = React.createContext(
  (_themeName: string): void => {}
);

const ThemeProviderWrapper = (props: Props) => {
  const curThemeName = localStorage.getItem('appTheme') || 'PureLightTheme';
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);
  const setThemeName = (_themeName: string): void => {
    localStorage.setItem('appTheme', themeName);
    _setThemeName(_themeName);
  };

  return (
    <ThemeContext.Provider value={setThemeName}>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProviderWrapper;
